import { IValidationRule } from "@/types"

const transportValidationRules: { [s: string]: IValidationRule } = {
    dimension: {
        type: "decimal",
        min: 0
    },
    payload: {
        type: "decimal",
        min: 0
    },
}

export default transportValidationRules
